export function getQuayUnlocode(quay) {
    return quay.URN.replace('urn:mrn:stm:location:', '')
        .split(':')[0]
        .toUpperCase();
}
